import '@vaadin/context-menu';
// eslint-disable-next-line no-duplicate-imports
import {
    ContextMenu,
    ContextMenuItem,
    ContextMenuItemSelectedEvent,
    ContextMenuOpenedChangedEvent,
} from '@vaadin/context-menu';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmBaseComponent } from '../tm-base.component';

const tagName = 'tm-context-menu';
@customElement(tagName)
export class TmContextMenu extends TmBaseComponent {
    @property({ type: Array })
    public items: Array<ContextMenuItem> = [];

    @property({ type: String })
    public closeOn = 'click';

    @property({ type: String })
    public openOn = 'vaadin-context-menu';

    @property({ type: String })
    public overlayClass = '';

    @property({ type: Boolean, reflect: true })
    public opened = false;

    protected render() {
        return html`
            <vaadin-context-menu
                .items=${this.items}
                .closeOn=${this.closeOn}
                .openOn=${this.openOn}
                .overlayClass=${this.overlayClass}
                @opened-changed=${(e: ContextMenuOpenedChangedEvent) => {
                    const openedChangedEvent = new CustomEvent('opened-changed', {
                        detail: e.detail,
                    });
                    this.dispatchEvent(openedChangedEvent);
                    this.opened = e.detail.value;
                }}
                @item-selected=${(e: ContextMenuItemSelectedEvent) => {
                    const itemSelectedEvent = new CustomEvent('item-selected', {
                        detail: e.detail,
                    });
                    this.dispatchEvent(itemSelectedEvent);
                    this.opened = (e.target as ContextMenu).opened;
                }}
            >
                <slot></slot>
            </vaadin-context-menu>
        `;
    }

    public static get styles() {
        return [
            css`
                :host {
                    --background: var(--container-primary);
                }
                vaadin-context-menu-overlay::part(overlay) {
                    background-color: var(--container-primary);
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmContextMenu;
    }
}
